import React, { useEffect, useRef, useState } from "react";

import styled from "styled-components";
// import { getPopmenuInfo } from '@/api/base'
import Header from '@/components/Header'
import bridge from '@/config/JSbridge'
import smoothscroll from 'smoothscroll-polyfill';
import  bwmodel from '@/config/bwmodel'
import Delivery from "./delivery";
// import ModalView from '@/components/modal-view'
import OpenApp from '../../components/OpenApp';
import { saveAddrInfo, getAddrInfo } from '@/api/user-new'
import { connect } from 'react-redux';
import { Toast } from "antd-mobile";
import h5Share from '@/utils/h5Share'
import Modal from './modal'

import { handleUploadTrace, getObjectFormSerach } from '@/utils'

// import { ModalContainer } from "../sku-exchange/style";
const Active_146 = ({token}) => {
  const active_id =  146;

  const [deliveryVisible, setDeliveryVisible] = useState(false);
  const deliveryRef = useRef('');
  const modelRef = useRef('');
    // const [showAddr,setShowAddr] = useState(false);
  const isStorm = bwmodel.app === 'storm';
  // const shareUrl = `#/active_${active_id}`
  const { source } = getObjectFormSerach(window.location.search);

  let getData = () => {
      const params = {
        activityId: active_id,
      }
       getAddrInfo(params)
          .then(res => {
            if(res.recipientPhone) {
              // setShowAddr(false)
              if (res) {
                deliveryRef.current.setParams(res);
              }
            } else {
              //
              // setShowAddr(true)
            }
            // console.log(res);
          })
  }

  useEffect(() => {
    document.title = '【火热开售】市值风云投资笔记';
    handleUploadTrace('ActivityPagelyuan')

    h5Share.main({
      title: `「投资笔记」— 投资实战手册`,
      desc: '从0到1，股市进阶手册。通过实战策略、案例模板、情绪周期，助你深入理解市场规律。',
      link: process.env.REACT_APP_DEMAND_URL + 'active_'+ active_id,
      thumbUrl: 'https://file.wogoo.com/app/logo/logo6.png',
      wxShare:{
        shareData:{
          imgUrl: 'https://file.wogoo.com/app/logo/logo6.png'
        }
      },
      shareData:{
        imgUrl: 'https://file.wogoo.com/app/logo/logo6.png'
      }
    })
    smoothscroll.polyfill();

    getData();

  }, [])



  const handleLeftClick = () => {
    // const bool =  showPopMenu && (count===0);
    // if(bool) {
    //   setShowModal(true);
    // } else {
    //   console.log('返回');
      bridge.callHandler('nativeEvent', {event: 'close', params: {
        isDelete: false
      }}, () => {})
    // }
  }

  const linkToDownload = () => {
    // 埋点
    // handleUploadTrace('7th-anniversary_link-download', 'click')
    //
    window.location.href = "https://m.wogoo.com/app/download/wogoo_client/index.html"
  }

  const handleLogin = () => {
    bridge.callHandler(
      'nativeEvent',
      {
        event: 'login',
        params: {
          refreshOnBack: true
        }
      },
      () => {}
    );
  }

    const handleSubmitAddr = (addr) => {
      const params = {
        activityId: active_id,
        ...addr,
        // giftList: [goodsName1 ,goodsName2]
      }

      saveAddrInfo(params)
      .then(res => {
        Toast.info('地址填写成功')
        setTimeout(()=> {
          // onClose();
          setDeliveryVisible(false);
          // setShowAddr(true);
        }, 1500)

      })
      .catch(err => {
        // onClose();
        console.log(err);
      })
    }

  const handleUnlock = () => {  //
    // if(!showPopMenu) {
    //   return Toast.info('活动已经结束')
    // }
    // 埋点
    if (source === 'mini') {
      /* eslint-disable no-undef */
      wx.miniProgram.navigateTo({url: '/pages/kefu/index'})
      return
    }
    if (!isStorm) {
      linkToDownload()
      return
    }
    if (!token) {
      handleLogin()
      return
    }
    const goods  = {
      skuPrice: 116,
      skuId: 166,
      goodsName: '大鳄周边',  // 此地写死，如复制需要注意
      spuId: '28'     // 此地写死，如复制需要注意
    }



    bridge.callHandler('nativeEvent', {
      event: 'halfScreenPay',
      params: {
        price: `${goods.skuPrice}`,
        activityTitle: goods.goodsName,
        skuId: `${goods.skuId}`,
        orderType: `${goods.spuId}`
      },
    }, (params) => {
      try {
        const info = JSON.parse(params)
        if (info && info.params.result) {
          // initPage()

          // bridge.callHandler('nativeEvent', {event: 'close', params: {
          //   isDelete: false
          // }}, () => {})


          // setShowModal(false);
//
          // 需要地址填写
          // setShowAddr(true);
          // setDeliveryVisible(true);
          // getData();

        }
      } catch (error) {
        //
      }
    })
  }




  function handleScroll(e) {
    // let footer = document.getElementById('footer');

    // if(footer) {
    //   if(window.scrollY >=20) {
    //     footer.classList.add('footer-freeclass-block');
    //   }else {
    //     footer.classList.remove('footer-freeclass-block');
    //   }
    // }

  }



  useEffect(()=>{
    window.addEventListener('scroll', handleScroll);
    return   window.addEventListener('scroll', null);
  }, [])

  return (
    <div>
      {
        isStorm && <Header
          title={'【火热开售】市值风云投资笔记'}
          leftClick={()=> {
            handleLeftClick()
          }}
          hideNaviBar
           right={
              bwmodel.compareVersion('4.17.9') ?( <img
              onClick={()=> {
                bridge.callHandler('nativeEvent', {
                    event: 'shareLink',
                    params: {
                      // shareLinkParams:{
                      title: `「投资笔记」— 投资实战手册`,
                      desc: '从0到1，股市进阶手册。通过实战策略、案例模板、情绪周期，助你深入理解市场规律。',
                      thumbUrl: 'https://file.wogoo.com/app/logo/logo6.png',
                      linkUrl: process.env.REACT_APP_DEMAND_URL + 'active_146',
                    }
                  })
              }}
              style={{width:'20px','vertical-align': 'middle'}}
              src={bwmodel.theme === '0' ? require(`@/img/share.png`):require(`@/img/share_dark.png`)}
              alt="分享"
            />
              )
          :''
            }
        />
      }

      <Container style={{marginTop: isStorm?'44px':'0px'}}>
       {/* <img className="first" src={require('./img/首图@2x.png')} alt="市值风云" /> */}
        <img className="member-img" src={require('./img/pic1@2x.png')} alt="市值风云" />
        <img className="member-img" src={require('./img/pic2@2x.png')} alt="市值风云" />
        <img className="member-img" src={require('./img/pic3@2x.png')} alt="市值风云" />
        <img className="member-img" src={require('./img/pic4@2x.png')} alt="市值风云" />
        <img className="member-img" src={require('./img/pic5@2x.png')} alt="市值风云" />
        <img className="member-img" src={require('./img/pic6@2x.png')} alt="市值风云" />
        <img className="member-img" src={require('./img/pic7@2x.png')} alt="市值风云" />
        <img className="member-img" src={require('./img/pic8@2x.png')} alt="市值风云" />
        <img className="member-img" src={require('./img/pic9@2x.png')} alt="市值风云" />
        <img className="member-img" src={require('./img/pic10@2x.png')} alt="市值风云" />
        
        {/* <img className="member-img" src={require('./img/日历10@2x.png')} alt="市值风云" />
        <img className="member-img" src={require('./img/日历12@2x.png')} alt="市值风云" />
        <img className="member-img" src={require('./img/日历13@2x.png')} alt="市值风云" />
        <img className="member-img" src={require('./img/日历14@2x.png')} alt="市值风云" /> */}
      <div className="footer footer-freeclass-block" id="footer">
        <p class='tips2'>市场有风险，投资需谨慎，本内容不构成任何投资建议。</p>
        <div className="btn" onClick={()=>{
           handleUnlock()
        }
          }>
          {/* <div>免费试用7天，解锁全部权益</div>
          <span>原价498元</span> */}
          <div>立即购买(116元)</div>
          <span>原价299元</span>
        </div>

      </div>
        <div className='fixed_box'
          onClick={()=>{
            setDeliveryVisible(true)
          }}
        >
          <img className="fixed_img" src={require('./img/悬浮球@2x.png')} alt="市值风云" />
        </div>

      </Container>


        <Modal ref={modelRef}/>
          <Delivery visible={deliveryVisible} ref={deliveryRef} onClose={() => setDeliveryVisible(false)} onSubmit={handleSubmitAddr} activityId={active_id} />

         {
            !isStorm && <OpenApp style={{marginBottom: '20px'}}  url={`${process.env.REACT_APP_DEMAND_URL}active_146`}></OpenApp>
          }
    </div>
  )
}


const Container = styled.div`
  background: #FFFFFF;
  padding-bottom:66px;
  img {
    vertical-align: middle;
    font-size:0;
    width:100%;
  }
  .first {
    margin-bottom: -37vw;
  }
  .member-img {
    box-sizing: border-box;;
  }
    .tips2 {
      padding: 0;
      margin:0;
      font-weight: 300;
      font-size: 12px;
      color: #9696A6;
      line-height: 17px;
      text-align: center;
      font-style: normal;

    }
    .footer {
      height: 76px;
      background: #ffffff;
      box-shadow: 0px 4px 16px 0px rgba(0,0,0,0.1);
       padding: 10px 4.1vw 0px;
       position: fixed;
      left: 0;
      right: 0;
      bottom: -126px;
     
      z-index: 10;
      transition: bottom 0.5s;
      &.footer-freeclass-block {
          bottom: 0;
      }
      .tips{
        padding: 10px;
        color: #FFF;
        text-align:center;
        time {
          color: #FFCD88;
        }
      }
      .btn {
        height: 44px;
        background: linear-gradient( 270deg, #F3BB6D 0%, #F7E2C3 100%);
        border-radius: 8px;
        font-size: 16px;
        color: #894618;
        text-align: center;
        position: relative;
        line-height: 44px;
        
        >span {
          position: absolute;
          right: 0px;
          width: 70px;
          height: 20px;
          background: #FF3446;
          border-radius: 0px 8px 0px 8px;
          color: #FFFFFF;
          text-decoration: line-through;
          top:0px;
          font-size:12px;
          line-height: 17px;
            
        }
      }
    }
@keyframes liuguang {
  00% {
    left: -105px;
  }

  20% {
    left: -15px;
  }
 
 
  100% {
    left: 50vw;
  }
}

.fixed_box {
  position: fixed;
  bottom: 120px;
  width: 48px;
  right: 10px;
}
`
// const ModalContainer = styled.div`
//   .modalCon {
//       position: relative;
//       img {
//         width:68.2vw;
//       }

//   }
//   .tips {
//     color: #FFFFFF;
//     position: absolute;
//     width:100%;
//     text-align:center;
//     top: 31vw;
//   }
//   .close {
//     display: block;
//     margin: 10px auto 0;
//   }
// `

// const ModalView =  styled.div`
//   position: fixed;
//   left: 0;
//   top: 0;
//   overflow: hidden;
//   width: 100%;
//   height: 100%;
//   z-index: 1000;
//   display: inline-block;
//   .bg {
//     position: absolute;
//     left: 0;
//     top: 0;
//     width: 100%;
//     height: 100%;
//     background: rgba(0,0,0,0.5);
//     z-index: 10;
//   }
//   .con {
//     position: absolute;
//     left: 0;
//     top: 0;
//     width: 100%;
//     height: 100%;
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     z-index: 11;
//   }

// `


const mapStateToProps = (state) => ({
  token: state.user.accessToken
});

export default React.memo(connect(mapStateToProps)(Active_146))



// WEBPACK FOOTER //
// ./src/views/activity_146/index.js